























































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from 'lodash-decorators';
import axios from 'axios';
import { api } from '@/api';
import { Action, Getter } from 'vuex-class';
import { Family } from '@/interfaces/Models';

@Component
export default class FamilyOverview extends Vue {
  public data: any = null;
  public loading: boolean = false;
  public familyName = null;
  public familyLoading: boolean = false;
  public families: any[] = [];
  public family: any = null;
  public familyRules: ((v: any) => void)[] = [
    (v: Family) => !!v || 'Family is required',
  ];

  public yearAndMonthMenu: boolean = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('familyName')
  @Debounce(500)
  onFamilyNameChange(value: string): void {
    let params = {
      paginate: 'no',
      family: value,
      potential_family: false,
    };
    this.familyLoading = true;

    if (value === null) {
      this.familyLoading = false;
      this.families = [];
      return;
    }

    axios.get(api.path('v1.admin.families'), { params: params }).then((res) => {
      this.familyLoading = false;
      this.families = res.data.data;
    });
  }

  @Action('transactions/setDate') setDate: any;
  @Getter('transactions/date') dateState: any;
  public get date(): string {
    return this.dateState;
  }

  public set date(date: string) {
    this.setDate(date);
  }

  public async fetchFamilyStatistics() {
    this.loading = true;
    axios
      .get(api.path('v1.admin.statistics.families'), {
        params: {
          date: this.date,
          id: this.family?.id ?? null,
        },
      })
      .then((res) => (this.data = res.data.data))
      .finally(() => (this.loading = false));
  }
}
